/**
 * Zod validators for the multi-provider LLM API surface (v2.0.0 PR #A-bis).
 *
 *   POST   /admin/settings/{provider}-key       body: { apiKey }
 *   DELETE /admin/settings/{provider}-key       no body
 *   POST   /admin/settings/{provider}-test      no body
 *   GET    /admin/llm-providers/status          no body
 *
 * The existing OpenAI routes (/admin/settings/openai-key etc.) keep their
 * own existing schemas in settings.schema.ts — this file is only for the 3
 * NEW providers. PR #B onward may consolidate.
 */
import { z } from 'zod';
import { LLM_PROVIDERS } from '../types/settings.js';
export const LlmProviderParamSchema = z.object({
    provider: z.enum(LLM_PROVIDERS),
});
export const SetLlmProviderKeyBodySchema = z.object({
    apiKey: z.string().trim().min(4).max(500),
});
/** GET /admin/llm-models?provider= */
export const LlmModelsQuerySchema = z.object({
    provider: z.enum(LLM_PROVIDERS),
});
/** POST /admin/llm-models/refresh — omit provider to refresh every saved key. */
export const LlmModelsRefreshSchema = z.object({
    provider: z.enum(LLM_PROVIDERS).optional(),
});
//# sourceMappingURL=llm-providers.schema.js.map